import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Permissions } from '@liveline/ll_node_common';
import { Action, LivelineSubject } from '@liveline/ll_node_common/lib/Permissions/types';
import { AbilityContext } from '../components/shared/Can';
import { ScreenKey } from '../permissions/screenKeys';

// True when the current user can VIEW the (LivelineControls-only) Cell Controller Tuning screen for the
// selected facility. Shared by the cross-page shortcuts (Advanced Controller header, Rules Configuration)
// so the subject key, facility source, and required action stay in one place.
export const useCanViewCellTuning = (): boolean => {
    const ability = useContext(AbilityContext);
    const facilityId = useSelector((s: any) => s?.userSelection?.facility?.livelineFacilityId);
    return ability && facilityId
        ? Permissions.checkAbility(
              ability,
              Action.VIEW,
              ScreenKey.CELL_CONTROLLER_TUNING as LivelineSubject,
              { facilityId },
          )
        : false;
};

export default useCanViewCellTuning;
